import { Flex, Heading } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { CustomizedTable } from "../../components/Common/Table/index";

const Customer = ({ customers }) => {
  const columns = [
    { Header: "ग्राहकाचे नाव", accessor: "name" },
    { Header: "दूरध्वनी", accessor: "phonenumber" },
    { Header: "पत्ता", accessor: "address" },
    {
      Header: "क्रिया",
      accessor: "id",
      Cell: ({ cell: { value } }) => (
        <Link
          to={`customer/detail/${value}`}
          style={{ fontWeight: "bold", color: "#3182ce" }}
        >
          पहा
        </Link>
      ),
    },
  ];

  // TO Select Row From Table And Do action on it
  let rowsToDelete = [];
  const selectId = async (data) => {
    rowsToDelete = [];
    data.map((data) => {
      rowsToDelete.push(data);
      return null;
    });
  };
  // const handleDelete = async () => {
  //   try {
  //     let customizedCustomersData = customers.map((data) => {
  //       let activeOrders = data?.orders.filter(
  //         (order) => order.isActive === true
  //       );
  //       return {
  //         ordersLength: activeOrders?.length,
  //         customerName: data.Name,
  //         customerId: data.id,
  //       };
  //     });
  //     rowsToDelete.map((row) => {
  //       return customizedCustomersData.map(async (data) => {
  //         if (data.customerId === row) {
  //           if (data.ordersLength !== 0) {
  //             return Notification(
  //               data.customerName,
  //               "यांची चालू मागणी आहे.कृपया आधी मागणी पूर्ण करावी किंवा हटवावी.",
  //               "error"
  //             );
  //           } else {
  //             await dispatch(deleteCustomer(row));
  //             return;
  //           }
  //         }
  //       });
  //     });
  //   } catch (err) {
  //     const errorMessage =
  //       (err?.response && err?.response?.data?.message) ||
  //       "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
  //     Notification("", errorMessage, "error");
  //   }
  // };

  return (
    <Flex
      mt={8}
      h="70vh"
      w="90%"
      marginX="auto"
      align="flex-start"
      p="5"
      direction="column"
    >
      <Flex w="100%" align="center">
        {/* <Button
          onClick={handleDelete}
          colorScheme="facebook"
          fontWeight="bold"
          fontSize="20px"
        >
          निवडलेले हटवा
        </Button> */}
        <Heading my="5px" w="95%" textAlign="center" alignItems="center">
          ग्राहकांचा तपशील
        </Heading>
      </Flex>

      <Flex w="100%" overflowX="scroll">
        <CustomizedTable
          column={columns}
          data={customers}
          onSelectRow={selectId}
        ></CustomizedTable>
      </Flex>
    </Flex>
  );
};

export default Customer;
